import React, { useEffect, useState } from 'react';
import { Button, Table, Checkbox, Tag, Select, Modal, message } from "antd";
import _ from "lodash";
import useRequest from '@/utils/useRequest';
import RoleSelect from './roleselect';
const { Option } = Select;

const Popedom = (props) => {
  const { request } = useRequest();
  const [funclist, setFunclist] = useState({});
  const [menulist, setMenulist] = useState({});
  const [selectRole, setSelectRole] = useState();
  const [list, setList] = useState([]);
  const [loading,setLoading] = useState(false);
  const popedoms = {};

  const getMenu = async () => {
    try {
      setLoading(true);
      let result = await request("/api/v2/private/menu/all", "POST", "json", {});
      if (result.success) {
        //组装成树形结构
        let filter = (pid) => {
          let tt = _.filter(result.data, (item) => { return item.ParentId == pid });
          return _.sortBy(tt, "SortNum");
        };
        let rdata = filter(null);
        rdata.forEach(element => {
          element.key = element.Id;
          const children = filter(element.Id);
          if (children.length > 0) {
            element.children = children;
            element.children.forEach(ele => {
              ele.key = ele.Id;
              const childrens = filter(ele.Id);
              if (childrens.length > 0) {
                ele.children = filter(ele.Id);
                ele.children.forEach(el => {
                  el.key = el.Id;
                });
              }
            });
          }
        });
        setList(rdata);
      } else {
        Modal.error({ content: result.message });
      }
    } catch(err){
      Modal.error({ content: err.message });
    }
    setLoading(false);
  }
  const getRolePopedomList = async (roleid) => {
    try {
      setLoading(true);
      let result = await request("/api/v2/private/role/popedom/by/roleid", "POST", "json", { roleid:roleid });
      if (result.success) {
        let menus = {};
        let funcs = {};
        _.forEach(result.data,(item)=>{
          if(item.PType == 1){
            menus[item.PopedomId] = true;
          } else {
            funcs[item.PopedomId] = true;
          }
        });
        setFunclist(funcs);
        setMenulist(menus);
      } else {
        Modal.error({ content: result.message });
      }
    } catch (err) {
      Modal.error({ content: err.message });
    }
    setLoading(false);
  }

  const selectPopedom = (type,resId) => {
    let menus = menulist;
    let funcs = funclist;
    if (type == 1) {
      menus[resId] = true;
    } else {
      funcs[resId] = true;
    }
    setMenulist(_.clone(menus));
    setFunclist(_.clone(funcs));
  }

  const unSelectPopedom = (type,resId) => {
    let menus = menulist;
    let funcs = funclist;
    if (type == 1) {
      delete menus[resId];
    } else {
      delete funcs[resId];
    }
    setMenulist(_.clone(menus));
    setFunclist(_.clone(funcs));
  }

  const savePopedom = async (roleid, funclist, menulist) => {
    try {
      setLoading(true);
      let result = await request("/api/v2/private/role/popedom/save", "POST", "json", { roleid:roleid, funclist:_.keys(funclist), menulist:_.keys(menulist) });
      if (result.success) {
        message.success({ content: result.message });
      } else {
        Modal.error({ content: result.message });
      }
    } catch (err) {
      Modal.error({ content: err.message });
    }
    setLoading(false);
  }


  useEffect(()=>{
    getMenu();
  },[]);

  useEffect(()=>{
    if(selectRole) {
      //获取指定角色包含权限
      getRolePopedomList(selectRole);
    }
  },[ selectRole ]);

  const columns = [{
    title: '菜单名称',
    dataIndex: 'Name'
  }, {
    title: '是否可见',
    render: (record) => {
      return (<Checkbox
        checked={menulist[record.Id] ? menulist[record.Id] : false}
        onChange={
          (e) => {
            if (e.target.checked) {
              selectPopedom(1, record.Id);
            } else {
              unSelectPopedom(1, record.Id);
            }
          }
        }></Checkbox>);
    }
  }, {
    title: '拥有功能',
    dataIndex: 'FuncInfos',
    render: (f) => {
      const funcArray = Array.isArray(f) ? f : [];
      if (funcArray) {
        return (<div>{funcArray.map((item, key) => {
          return (<Tag.CheckableTag
            checked={funclist[item.Id] ? funclist[item.Id] : false}
            onChange={() => {
              if (funclist[item.Id]) {
                unSelectPopedom(2, item.Id);
              } else {
                selectPopedom(2, item.Id);
              }
            }}
          >{item.FuncName}({item.Id})</Tag.CheckableTag>)
        })}</div>);
      } else {
        return null;
      }
    }
  }];
  return (
    <div className="p-4 max-h-[calc(100vh-5.25rem)] overflow-y-auto">
      <div className="">
        <div className="flex flex-row items-center justify-between mb-4">
          <RoleSelect value={selectRole} onChange={(e) => {
              setSelectRole(e);
              //getRolePopedomList(e);
            }} />
          <Button type='primary' className="popedom-save-btn" onClick={() => {
            savePopedom(selectRole, funclist, menulist);
          }}>保存权限</Button>
        </div>

        <div className="mb-4">分配角色权限如下：</div>
        <Table columns={columns} size="small"
          pagination={{ pageSize: 50 }}
          loading={loading}
          //pagination={false}
          dataSource={list}
        />
      </div>
    </div>
  );
}

export default Popedom;